import { useState } from 'react';
import { Link } from 'react-router-dom';
import IconChevronLeft from '~~elements/static/IconChevronLeft.svg';
import DefaultAvatar from '~~elements/static/DefaultAvatar.jpg';
import { inDev, startedFlash } from '~~commonUtils';
import { FLASH_EVENT } from '~~commonConst';
import Multilingual from './Multilingual';
import { StyledDiv } from '../Settings/Styles';
import { useRootState } from '../../useRoot';
import ListPluginOrders from './components/ListPluginOrders';
import PaymentResult from './components/PaymentResult';
import PluginOrderDetail from './components/PluginOrderDetail';

const MyPluginOrder = ({ pluginOrders }) => {
  const { loginInfo } = useRootState();

  const [pluginOrder, setPluginOrder] = useState(null);

  const handlePluginOrder = (order) => () => {
    setPluginOrder(order);
  };

  const closePluginOrder = () => {
    setPluginOrder(null);
  };

  return (
    <StyledDiv>
      <div className="greet">
        <img className="greet--pic" src={loginInfo.avatarUrl ? loginInfo.avatarUrl : DefaultAvatar} alt="" />
        <div className="greet--name">{Multilingual(`MY_PLUGIN_ORDER`)}</div>
      </div>
      <div className="panel">
        <div className="multi-section-list">
          <div className="section-list">
            <div className="section-list--title" />
            <Link
              className="section-list--item"
              to={() => ({
                pathname: `/settings/user_profile`,
              })}
            >
              <img style={{ width: '1rem', height: '1rem' }} src={IconChevronLeft} alt="back" />
              {Multilingual(`ACCOUNT_MANAGEMENT.WORDING`)}
            </Link>
          </div>
          <div className="section-list">
            <div className="section-list--title" />
            {(inDev() || startedFlash(FLASH_EVENT['2022_ONCE_MEMBER'])) && (
              <a className="section-list--item" href={`${process.env.REACT_APP_MAINPAGE_URL}/member`}>
                限時活動！
              </a>
            )}
            {/* <Link
              className="section-list--item"
              to={() => ({
                pathname: `/shop/plugin`,
              })}
            >
              平台擴充套件
            </Link> */}
          </div>
        </div>
        <div className="section lg">
          <ListPluginOrders pluginOrders={pluginOrders} handlePluginOrder={handlePluginOrder} />
        </div>
      </div>
      <PaymentResult />
      {pluginOrder && <PluginOrderDetail pluginOrder={pluginOrder} toClose={closePluginOrder} />}
    </StyledDiv>
  );
};

export default MyPluginOrder;
